(function () {
    'use strict';

    angular
        .module('elogbooks.admin.site-associations')
        .controller('SiteApprovalsReassignController', SiteApprovalsReassignController);

    SiteApprovalsReassignController.$inject = [
        'userResponse',
        'siteApproverTypeCollectionResponse',
        'apiClient',
        '$q',
        'approverUsersResponse',
        '$state',
        '$stateParams',
        'messenger',
        '$translate',
        '$scope',
        '$timeout',
        'rootResourceResponse',
        'siteGroupCollectionResponse',
        'coreClientCollectionResponse',
        'siteReassignFiltersService',
        'siteAccessConfirmationModal'
    ];

    function SiteApprovalsReassignController(
        userResponse,
        siteApproverTypeCollectionResponse,
        apiClient,
        $q,
        approverUsersResponse,
        $state,
        $stateParams,
        messenger,
        $translate,
        $scope,
        $timeout,
        rootResourceResponse,
        siteGroupCollectionResponse,
        coreClientCollectionResponse,
        siteReassignFiltersService,
        siteAccessConfirmationModal
    ) {
        var vm = this;
        var approvalTypeLabels = {
            reactiveJobApprovers: 'REACTIVE_JOB_APPROVERS',
            reactiveJobExtensionsApprovers: 'REACTIVE_JOB_EXTENSIONS_APPROVERS',
            plannedJobApprovers: 'PLANNED_JOB_APPROVERS',
            plannedJobExtensionsApprovers: 'PLANNED_JOB_EXTENSIONS_APPROVERS',
            quoteApprovers: 'QUOTE_APPROVERS',
            contractApprovers: 'CONTRACT_APPROVERS',
            surveyApprovers: 'SURVEY_APPROVERS'
        };

        vm.user = userResponse;
        vm.approvalTypes = [];
        vm.hasApprovalTypes = false;
        vm.approvalTypesLoading = false;
        vm.somethingIsSelected = false;
        vm.displaySummary = false;
        vm.summary = [];
        vm.summaryLoading = false;
        vm.disableUpdate = false;
        vm.submittingUpdate = false;
        var filters = siteReassignFiltersService.create(rootResourceResponse, $stateParams, {
            siteGroup: siteGroupCollectionResponse,
            coreClient: coreClientCollectionResponse
        });
        vm.criteria = filters.criteria;
        vm.filterStateParams = filters.stateParams;
        vm.selectedApproverModel = {
            response: approverUsersResponse,
            link: approverUsersResponse.getLink('self'),
            linkParameters: {
                membershipPermission: ['site_permission_can_be_approver'],
                status: 'active',
                'excludeUserIds[]': userResponse.id
            },
            responseKeyPath: 'users',
            itemValuePath: 'name'
        };
        var missingSitesAccessLink = siteApproverTypeCollectionResponse.getLink('reassign-approvals-missing-sites-access');
        var missingSitesAccessCache = {};

        vm.toggleApprovalType = toggleApprovalType;
        vm.toggleSiteSelection = toggleSiteSelection;
        vm.onSelectSite = updateSelection;
        vm.updateIndeterminate = updateIndeterminate;
        vm.selectAll = selectAll;
        vm.deselectAll = deselectAll;
        vm.reassignSelected = reassignSelected;
        vm.update = update;
        vm.cancel = cancel;
        vm.applyFilters = applyFilters;
        vm.selectedSitesCount = selectedSitesCount;
        var appliedFilterParams = siteReassignFiltersService.getApiParams(null, vm.criteria);

        loadApprovalTypes();

        $scope.$watch(function () {
            return vm.selectedApproverModel.selected &&
                vm.selectedApproverModel.selected.object &&
                vm.selectedApproverModel.selected.object.id;
        }, function (userId) {
            if (userId) {
                getMissingSitesAccess().catch(function () {});
            }
        });

        function toggleApprovalType(approvalType) {
            approvalType.expanded = !approvalType.expanded;

            if (approvalType.expanded && !approvalType.sitesLoaded && !approvalType.sitesLoading) {
                loadSites(approvalType);
            }
        }

        function loadApprovalTypes() {
            vm.approvalTypes = (siteApproverTypeCollectionResponse.siteApproverTypes || []).map(createApprovalType);
            vm.hasApprovalTypes = vm.approvalTypes.length > 0;
        }

        function applyFilters(criteriaParams) {
            vm.filterStateParams = siteReassignFiltersService.getStateParams(criteriaParams);

            return $state.go('.', vm.filterStateParams, {
                reload: $state.current
            });
        }

        function selectedSitesCount(approvalType) {
            if (approvalType.selectAllSites) {
                var siteCount = parseInt(approvalType.siteCount, 10) || approvalType.sites.length;

                return Math.max(siteCount - approvalType.deselectedSiteIds.length, 0);
            }

            if (approvalType.selectedSiteIds.length) {
                return approvalType.selectedSiteIds.length;
            }

            return approvalType.sites.filter(function (site) {
                return site.selected;
            }).length;
        }

        function appendSites(approvalType, response) {
            if (!response || !response.sites) {
                return;
            }

            approvalType.sites = approvalType.sites.concat(response.sites);
            approvalType.nextLink = response.getLink('next');
            approvalType.sitesLoaded = !approvalType.nextLink;

            if (approvalType.selectAllSites) {
                approvalType.sites.forEach(function (site) {
                    site.selected = approvalType.deselectedSiteIds.indexOf(parseInt(site.id, 10)) === -1;
                });
                vm.somethingIsSelected = true;
            } else if (approvalType.selectedSiteIds.length) {
                approvalType.sites.forEach(function (site) {
                    if (approvalType.selectedSiteIds.indexOf(parseInt(site.id, 10)) !== -1) {
                        site.selected = true;
                    }
                });
            }

            updateSelection(approvalType);

            if (vm.displaySummary && approvalType.forceLoadAllSites) {
                refreshSummary();
            }
        }

        function shouldLoadNextSitesPage(approvalType) {
            return approvalType.nextLink &&
                (approvalType.forceLoadAllSites || (!vm.displaySummary && approvalType.expanded));
        }

        function loadSitesPage(approvalType, link, parameters) {
            return apiClient.get(link, parameters).then(function (response) {
                appendSites(approvalType, response);

                if (shouldLoadNextSitesPage(approvalType)) {
                    return loadSitesPage(approvalType, approvalType.nextLink);
                }
            }).finally(function () {
                approvalType.sitesLoading = false;
            });
        }

        function loadSites(approvalType, forceLoadAllSites, filterParams) {
            if (forceLoadAllSites) {
                approvalType.forceLoadAllSites = true;
            }

            if (approvalType.sitesPromise) {
                return approvalType.sitesPromise;
            }

            approvalType.sitesLoading = true;

            approvalType.sitesPromise = loadSitesPage(
                approvalType,
                approvalType.nextLink || approvalType.sitesLink,
                filterParams || appliedFilterParams
            ).catch(function (error) {
                console.error('Error loading site approver sites', error, approvalType);
            }).finally(function () {
                approvalType.sitesLoaded = !approvalType.nextLink;
                approvalType.sitesPromise = null;
                approvalType.forceLoadAllSites = false;
                updateSelection(approvalType);
            });

            return approvalType.sitesPromise;
        }

        function toggleSiteSelection(approvalType) {
            if (approvalType.indeterminate) {
                deselectApprovalType(approvalType);
                return;
            }

            if (approvalType.selected) {
                selectApprovalType(approvalType);
                return;
            }

            deselectApprovalType(approvalType);
        }

        function selectApprovalType(approvalType) {
            approvalType.selected = true;
            approvalType.selectAllSites = true;
            approvalType.selectedSiteIds = [];
            approvalType.deselectedSiteIds = [];

            approvalType.sites.forEach(function (site) {
                site.selected = true;
            });

            vm.somethingIsSelected = true;
            updateIndeterminate(approvalType);
        }

        function deselectApprovalType(approvalType) {
            approvalType.selected = false;
            approvalType.selectAllSites = false;
            approvalType.selectedSiteIds = [];
            approvalType.deselectedSiteIds = [];

            approvalType.sites.forEach(function (site) {
                site.selected = false;
            });

            updateSelection(approvalType);
        }

        function selectAll() {
            vm.somethingIsSelected = true;

            vm.approvalTypes.forEach(function (approvalType) {
                approvalType.selected = true;
                approvalType.selectAllSites = true;
                approvalType.selectedSiteIds = [];
                approvalType.deselectedSiteIds = [];

                approvalType.sites.forEach(function (site) {
                    site.selected = true;
                });

                updateIndeterminate(approvalType);
            });
        }

        function deselectAll() {
            vm.somethingIsSelected = false;

            vm.approvalTypes.forEach(function (approvalType) {
                approvalType.selected = false;
                approvalType.selectAllSites = false;
                approvalType.selectedSiteIds = [];
                approvalType.deselectedSiteIds = [];

                approvalType.sites.forEach(function (site) {
                    site.selected = false;
                });

                updateIndeterminate(approvalType);
            });
        }

        function updateIndeterminate(approvalType) {
            var el = document.getElementById('approval-type-' + approvalType.uniqueId);
            var total = approvalType.sites.length;
            var checkedCount = approvalType.sites.filter(function (site) {
                return site.selected;
            }).length;

            approvalType.indeterminate = approvalType.selectAllSites
                ? approvalType.deselectedSiteIds.length > 0 && selectedSitesCount(approvalType) > 0
                : checkedCount > 0 && checkedCount < total;

            if (el) {
                el.indeterminate = !!approvalType.indeterminate;
            }
        }

        function updateSelection(approvalType) {
            if (approvalType.selectAllSites) {
                syncDeselectedSiteIds(approvalType);

                if (selectedSitesCount(approvalType) === 0) {
                    approvalType.selected = false;
                    approvalType.selectAllSites = false;
                    approvalType.selectedSiteIds = [];
                    approvalType.deselectedSiteIds = [];
                } else {
                    approvalType.selected = true;
                    approvalType.selectedSiteIds = [];
                }

                updateIndeterminate(approvalType);
                updateSomethingIsSelected();
                return;
            }

            var hasSelectedSite = approvalType.sites.some(function (site) {
                return site.selected;
            });
            var allLoadedSitesSelected = approvalType.sites.length > 0 && approvalType.sites.every(function (site) {
                return site.selected;
            });

            if (hasSelectedSite) {
                approvalType.selected = true;
            } else {
                approvalType.selected = false;
                approvalType.selectAllSites = false;
            }

            if (approvalType.sites.length > 0) {
                approvalType.selectAllSites = approvalType.selectAllSites && allLoadedSitesSelected;

                if (!approvalType.selectAllSites) {
                    approvalType.deselectedSiteIds = [];
                    approvalType.selectedSiteIds = approvalType.sites
                        .filter(function (site) {
                            return site.selected;
                        })
                        .map(function (site) {
                            return parseInt(site.id, 10);
                        });
                }
            }

            updateIndeterminate(approvalType);
            updateSomethingIsSelected();
        }

        function updateSomethingIsSelected() {
            vm.somethingIsSelected = vm.approvalTypes.some(function (type) {
                return type.selected || type.sites.some(function (site) {
                    return site.selected;
                });
            });
        }

        function syncDeselectedSiteIds(approvalType) {
            approvalType.sites.forEach(function (site) {
                var siteId = parseInt(site.id, 10);
                var deselectedIndex = approvalType.deselectedSiteIds.indexOf(siteId);

                if (site.selected && deselectedIndex !== -1) {
                    approvalType.deselectedSiteIds.splice(deselectedIndex, 1);
                    return;
                }

                if (!site.selected && deselectedIndex === -1) {
                    approvalType.deselectedSiteIds.push(siteId);
                }
            });
        }

        function createApprovalType(siteApproverType, selectedSiteIds) {
            selectedSiteIds = selectedSiteIds || [];

            return {
                key: siteApproverType.key,
                title: approvalTypeLabels[siteApproverType.key],
                order: Object.keys(approvalTypeLabels).indexOf(siteApproverType.key),
                sitesLink: siteApproverType.getLink('sites'),
                siteCount: siteApproverType.siteCount,
                expanded: false,
                visible: true,
                selected: selectedSiteIds.length > 0,
                selectAllSites: false,
                indeterminate: false,
                sitesLoaded: false,
                sitesLoading: false,
                sitesPromise: null,
                forceLoadAllSites: false,
                nextLink: null,
                selectedSiteIds: selectedSiteIds,
                deselectedSiteIds: [],
                uniqueId: Date.now().toString(36) + Math.random().toString(36).substr(2),
                sites: []
            };
        }

        function reassignSelected() {
            vm.displaySummary = true;
            vm.summaryLoading = true;
            vm.summary = [];

            refreshSummary();

            var promises = vm.approvalTypes
                .filter(function (approvalType) {
                    return shouldLoadSitesForSummary(approvalType);
                })
                .map(function (approvalType) {
                    return loadSites(approvalType, true);
                });

            return $q.all(promises).then(function () {
                refreshSummary();
            }).finally(function () {
                vm.summaryLoading = false;
            });
        }

        function shouldLoadSitesForSummary(approvalType) {
            if (!approvalType.selected || approvalType.sitesLoaded) {
                return false;
            }

            if (approvalType.selectAllSites) {
                return true;
            }

            return hasMissingSelectedSites(approvalType);
        }

        function hasMissingSelectedSites(approvalType) {
            if (!approvalType.selectedSiteIds.length) {
                return false;
            }

            var loadedSiteIds = approvalType.sites.map(function (site) {
                return parseInt(site.id, 10);
            });

            return approvalType.selectedSiteIds.some(function (siteId) {
                return loadedSiteIds.indexOf(parseInt(siteId, 10)) === -1;
            });
        }

        function refreshSummary() {
            var summary = [];

            vm.approvalTypes.forEach(function (approvalType) {
                approvalType.sites.forEach(function (site) {
                    if (!site.selected) {
                        return;
                    }

                    summary.push({
                        id: site.id,
                        name: site.name,
                        approvalType: approvalType.title,
                        approvalTypeKey: approvalType.key,
                        approvalTypeOrder: approvalType.order,
                        hierarchy: site.prefix
                    });
                });
            });

            vm.summary = sortSummary(summary);
        }

        function sortSummary(summary) {
            var hierarchyOrder = {
                Primary: 0,
                Secondary: 1,
                Tertiary: 2,
                Other: 3
            };

            function getHierarchyOrder(item) {
                return hierarchyOrder.hasOwnProperty(item.hierarchy)
                    ? hierarchyOrder[item.hierarchy]
                    : hierarchyOrder.Other;
            }

            return summary.sort(function (a, b) {
                var approvalTypeCompare = a.approvalTypeOrder - b.approvalTypeOrder;

                if (approvalTypeCompare !== 0) {
                    return approvalTypeCompare;
                }

                var hierarchyCompare = getHierarchyOrder(a) - getHierarchyOrder(b);

                if (hierarchyCompare !== 0) {
                    return hierarchyCompare;
                }

                return (a.name || '').localeCompare(b.name || '');
            });
        }

        function buildReassignData() {
            var reassignData = {};

            vm.summary.forEach(function (item) {
                var siteId = parseInt(item.id, 10);

                if (!reassignData[item.approvalTypeKey]) {
                    reassignData[item.approvalTypeKey] = [];
                }

                if (reassignData[item.approvalTypeKey].indexOf(siteId) === -1) {
                    reassignData[item.approvalTypeKey].push(siteId);
                    reassignData[item.approvalTypeKey].sort(function (a, b) {
                        return a - b;
                    });
                }
            });

            return reassignData;
        }

        function getSelectedSiteIds() {
            var siteIds = [];

            vm.summary.forEach(function (item) {
                var siteId = parseInt(item.id, 10);

                if (siteIds.indexOf(siteId) === -1) {
                    siteIds.push(siteId);
                }
            });

            return siteIds;
        }

        function getMissingSitesAccess() {
            var selectedApprover = vm.selectedApproverModel.selected && vm.selectedApproverModel.selected.object;
            var userId = selectedApprover && selectedApprover.id;

            if (!userId || !missingSitesAccessLink) {
                return $q.resolve([]);
            }

            if (missingSitesAccessCache.hasOwnProperty(userId)) {
                return $q.when(missingSitesAccessCache[userId]);
            }

            missingSitesAccessCache[userId] = apiClient.get(missingSitesAccessLink, {
                comparingUser: userId
            }).then(function (response) {
                if (!response) {
                    delete missingSitesAccessCache[userId];
                    return $q.reject('REQUEST_ERROR');
                }

                missingSitesAccessCache[userId] = response && response.sites ? response.sites : [];

                return missingSitesAccessCache[userId];
            }).catch(function (error) {
                delete missingSitesAccessCache[userId];
                console.error('Error loading missing site approver access', error);

                return $q.reject(error);
            });

            return missingSitesAccessCache[userId];
        }

        function getSelectedMissingSiteNames() {
            var selectedSiteIds = getSelectedSiteIds();

            return getMissingSitesAccess().then(function (sites) {
                return sites
                    .filter(function (site) {
                        return selectedSiteIds.indexOf(parseInt(site.id, 10)) !== -1;
                    })
                    .map(function (site) {
                        return site.name;
                    })
                    .sort(function (a, b) {
                        return a.localeCompare(b);
                    });
            });
        }

        function submitReassign(selectedApprover) {
            vm.submittingUpdate = true;

            return apiClient.create(siteApproverTypeCollectionResponse.getLink('reassign'), {
                _links: {
                    approver: [{
                        id: selectedApprover.id,
                        href: selectedApprover.getLink('self')
                    }]
                },
                reassignData: buildReassignData()
            }).then(function (response) {
                if (!response) {
                    vm.disableUpdate = false;
                    vm.submittingUpdate = false;
                    messenger.error('REQUEST_ERROR');
                    return;
                }

                $state.go($state.current.name, {}, {reload: true}).then(function () {
                    messenger.success('REASSIGN_APPROVAL_SUCCESS');
                });
            }).catch(function () {
                vm.disableUpdate = false;
                vm.submittingUpdate = false;
                messenger.error('REQUEST_ERROR');
            });
        }

        function openConfirmationModal(selectedApprover, missingSites) {
            var body = $translate.instant('REASSIGN_APPROVAL_CONFIRMATION_BODY', {
                selectedApprover: selectedApprover
            });

            if (missingSites.length > 0) {
                body += '<br><br>' + $translate.instant('SITE_ACCESS_CONFIRMATION_MESSAGE', {
                    userName: selectedApprover.name,
                    count: missingSites.length
                });
            }

            return siteAccessConfirmationModal.open({
                titleMessage: 'REASSIGN_APPROVAL_CONFIRMATION',
                bodyMessage: body,
                primaryText: 'CONFIRM',
                primaryClass: 'btn-success',
                secondaryText: 'CANCEL',
                secondaryClass: 'btn-default',
                sites: missingSites
            });
        }

        function update() {
            var selectedApprover = vm.selectedApproverModel.selected && vm.selectedApproverModel.selected.object;

            if (vm.disableUpdate || vm.submittingUpdate || !selectedApprover || !selectedApprover.id) {
                return;
            }

            vm.disableUpdate = true;

            getSelectedMissingSiteNames().then(function (missingSites) {
                if (!vm.displaySummary) {
                    vm.disableUpdate = false;
                    return;
                }

                openConfirmationModal(selectedApprover, missingSites).result.then(function () {
                    submitReassign(selectedApprover);
                }).catch(function () {
                    vm.disableUpdate = false;
                });
            }).catch(function (error) {
                if (!vm.displaySummary) {
                    vm.disableUpdate = false;
                    return;
                }

                vm.disableUpdate = false;
                console.error('Error preparing site approver reassignment confirmation', error);
                messenger.error('REQUEST_ERROR');
            });
        }

        function cancel() {
            vm.displaySummary = false;
            vm.summary = [];
            vm.summaryLoading = false;
            vm.disableUpdate = false;

            vm.approvalTypes.forEach(function (approvalType) {
                approvalType.forceLoadAllSites = false;
            });

            $timeout(function () {
                vm.approvalTypes.forEach(function (approvalType) {
                    updateIndeterminate(approvalType);

                    if (approvalType.expanded && !approvalType.sitesLoaded && !approvalType.sitesLoading) {
                        loadSites(approvalType);
                    }
                });
            });
        }
    }
})();
